import { Helmet } from 'react-helmet';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import { useIntl } from 'react-intl';
import { Tabs } from 'antd';

import InvoicingOverview from '@/components/Charts/InvoicingOverview';
import InvoicingBillingXPaymentsXReceipts from '@/components/Charts/InvoicingBillingXPaymentsXReceipts';
import InvoicingBillingXTicketsXAverageTicket from '@/components/Charts/InvoicingBillingXTicketsXAverageTicket';
import InvoicingAverageTicket from '@/components/Charts/InvoicingAverageTicket';

const InvoicingChartsPage = ({ route }: PageProps) => {
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DefaultRouteTabs
        route={route.parent}
        basePath="/app/managementCharts"
        permissions={route.permissions}
      >
        <Tabs defaultActiveKey="overview">
          <Tabs.TabPane tab="Visão Geral" key="overview">
            <InvoicingOverview />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab="Faturamento x Pagamentos x Recebimentos"
            key="billingXPaymentsXReceipts"
          >
            <InvoicingBillingXPaymentsXReceipts />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab="Faturamento x Passagens x Ticket Médio"
            key="billingXTicketsXAverageTicket"
          >
            <InvoicingBillingXTicketsXAverageTicket />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab="Ticket Médio (Peças x Serviços)"
            key="averageTicket"
          >
            <InvoicingAverageTicket />
          </Tabs.TabPane>
        </Tabs>
      </DefaultRouteTabs>
    </>
  );
};

export default InvoicingChartsPage;
